import { Box, Typography } from "@mui/material";
import IntegrationImage from "../../../../integrations/components/IntegrationImage";
import TextIntegrationStyle from "../../TextIntegrationStyle";

const HostClassificationView = ({ entityData }) => {
  return (
    <Box display={"flex"} flexDirection={"column"} gap={2} pb={2}>
      {entityData?.servicenow_cmdb_data?.crown_jewel != null && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant={"subtitle2"}>Crown Jewel</Typography>
          </Box>
          <Box display={"flex"} gap={2} ml={3}>
            <TextIntegrationStyle
              title={
                <Box display={"flex"}>
                  <IntegrationImage
                    name={"servicenow_cmdb"}
                    width={"12px"}
                    newLogo={true}
                  />
                </Box>
              }
              value={
                entityData?.servicenow_cmdb_data?.crown_jewel ? "Yes" : "No"
              }
            />
          </Box>
        </Box>
      )}
      {entityData?.servicenow_cmdb_data?.environment && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant={"subtitle2"}>Environment</Typography>
          </Box>
          <Box display={"flex"} gap={2} ml={3}>
            <TextIntegrationStyle
              title={
                <Box display={"flex"}>
                  <IntegrationImage
                    name={"servicenow_cmdb"}
                    width={"12px"}
                    newLogo={true}
                  />
                </Box>
              }
              value={entityData?.servicenow_cmdb_data?.environment}
            />
          </Box>
        </Box>
      )}
      {entityData?.servicenow_cmdb_data?.is_global != null && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant={"subtitle2"}>Is Global</Typography>
          </Box>
          <Box display={"flex"} gap={2} ml={3}>
            <TextIntegrationStyle
              title={
                <Box display={"flex"}>
                  <IntegrationImage
                    name={"servicenow_cmdb"}
                    width={"12px"}
                    newLogo={true}
                  />
                </Box>
              }
              value={entityData?.servicenow_cmdb_data?.is_global ? "Yes" : "No"}
            />
          </Box>
        </Box>
      )}
      {entityData?.servicenow_cmdb_data?.sys_class_name && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant={"subtitle2"}>System Class Name</Typography>
          </Box>
          <Box display={"flex"} gap={2} ml={3}>
            <TextIntegrationStyle
              title={
                <Box display={"flex"}>
                  <IntegrationImage
                    name={"servicenow_cmdb"}
                    width={"12px"}
                    newLogo={true}
                  />
                </Box>
              }
              value={entityData?.servicenow_cmdb_data?.sys_class_name}
            />
          </Box>
        </Box>
      )}
      {entityData?.servicenow_cmdb_data?.sys_tags && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant={"subtitle2"}>System Tags</Typography>
          </Box>
          <Box display={"flex"} gap={2} ml={3}>
            <TextIntegrationStyle
              title={
                <Box display={"flex"}>
                  <IntegrationImage
                    name={"servicenow_cmdb"}
                    width={"12px"}
                    newLogo={true}
                  />
                </Box>
              }
              value={entityData?.servicenow_cmdb_data?.sys_tags}
            />
          </Box>
        </Box>
      )}
      {entityData?.servicenow_cmdb_data?.application_id_tag && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant={"subtitle2"}>Application ID Tag</Typography>
          </Box>
          <Box display={"flex"} gap={2} ml={3}>
            <TextIntegrationStyle
              title={
                <Box display={"flex"}>
                  <IntegrationImage
                    name={"servicenow_cmdb"}
                    width={"12px"}
                    newLogo={true}
                  />
                </Box>
              }
              value={entityData?.servicenow_cmdb_data?.application_id_tag}
            />
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default HostClassificationView;
